import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import { featureAccess } from "../permissions/access";
import { useUserRole } from "../utils/hooks/useUserRole";
import BranchTable from "../components/Branch/BranchTable";
import CreateBranchDialog from "../components/Branch/CreateBranchDialog";

export default function BranchListPage() {
  const role = useUserRole();
  const canCreateBranch = featureAccess.branchManagementWrite(role);
  const [createOpen, setCreateOpen] = useState<boolean>(false);

  const handleOpenCreate = () => setCreateOpen(true);
  const handleCloseCreate = () => setCreateOpen(false);

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        gap={2}
        mb={2}
        flexWrap="wrap"
      >
        <Box>
          <Typography variant="h6" fontWeight={700}>
            สาขา
          </Typography>
          <Typography variant="body2" color="text.secondary">
            รายการสาขา · จำนวนสายที่เปิดใช้ · ความพร้อมก่อนเปิดใช้สาย
          </Typography>
        </Box>
        {canCreateBranch && (
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpenCreate}>
            สร้างสาขาใหม่
          </Button>
        )}
      </Stack>

      <BranchTable />

      {canCreateBranch && (
        <CreateBranchDialog open={createOpen} onClose={handleCloseCreate} />
      )}
    </Box>
  );
}
